const notches = [1,2,3,4];
export {notches}